// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- HS Code
import { InteractionAuthorizationBaseService } from './interaction-authorization-base.service';

// --- HS Code
import { OidcService } from '../account/oidc.service';
import { AppService } from '../app.service';

// #endregion

@Injectable({
  providedIn: 'root',
})
export class InteractionAuthorizationService extends InteractionAuthorizationBaseService {
  constructor(
    private oidcService: OidcService,
    appService: AppService
  ) {
    super(appService);
  }

  validateInteractionToken(id: string): void {
    if (!id) {
      return;
    }

    this.oidcService.identity$.subscribe((identity) => {
      if (identity) {
        this.oidcService.signOutRedirect();
      } else {
        this.oidcService.signInRedirect({
          extraQueryParams: {
            token: id,
            acr_values: 'otac:' + id,
          },
        });
      }
    });
    return;
  }
}
